import { cx } from '@linaria/core';

import type { SizeIconButtonBaseProps } from '~shared/ui/atoms';
import { SizeIconButtonBase } from '~shared/ui/atoms';

import { styledButton } from '../styles';

export const ButtonIconTertiary = ({
	className,
	...props
}: SizeIconButtonBaseProps) => {
	return (
		<SizeIconButtonBase className={cx(styledButton, className)} {...props} />
	);
};
